/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Nimetön sivu',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': 'Luo uusi sivu ja lisää se linkkinä',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Luo Confluence-sivu',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Avaa Confluencessa',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Sivusi on luotu',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Sivu luotu',
  'editorExtensionLinkCreate.confluencePage.title': 'Luo uusi sivu',
  'editorExtensionLinkCreate.genericError.description': 'Päivitä sivu ja yritä uudelleen.',
  'editorExtensionLinkCreate.genericError.title': 'Jokin meni vikaan',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description': 'Luo asia tekstiin sitoutuen ja lisää asia linkkinä',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Luo Jira-asia',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Avaa Jirassa',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Asiasi on luotu',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Asia luotu',
  'editorExtensionLinkCreate.jiraIssue.title': 'Luo uusi asia',
  'editorExtensionLinkCreate.keyword.create': 'luo',
  'editorExtensionLinkCreate.keyword.issue': 'asia',
  'editorExtensionLinkCreate.keyword.new': 'uusi',
  'editorExtensionLinkCreate.keyword.page': 'sivu',
  'editorExtensionLinkCreate.keyword.publish': 'julkaise',
  'editorExtensionLinkCreate.keyword.raise': 'tuo',
  'editorExtensionLinkCreate.keyword.space': 'työtila',
  'editorExtensionLinkCreate.keyword.ticket': 'tukipyyntö',
};
